import { posts } from "@/mocks/posts";
import { faqs } from "@/mocks/faqs";
import HeroSection from "@/pages/home/components/HeroSection";
import TodayUpdates from "@/pages/home/components/TodayUpdates";
import CategoryBoard from "@/pages/home/components/CategoryBoard";
import RankingSection from "@/pages/home/components/RankingSection";
import SummaryPreview from "@/pages/home/components/SummaryPreview";
import FaqSection from "@/pages/home/components/FaqSection";
import JsonLd from "@/components/feature/JsonLd";
import usePageMeta from "@/hooks/usePageMeta";

const sorted = [...posts].sort((a, b) => b.date.localeCompare(a.date));
const latestDate = sorted[0]?.date ?? "2026-09-12";
const todayCount = sorted.filter((p) => p.date === latestDate).length;

function formatDateLabel(dateStr: string) {
  const date = new Date(`${dateStr}T00:00:00`);
  const week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  return `${date.getFullYear()} 年 ${date.getMonth() + 1} 月 ${date.getDate()} 日 · ${week[date.getDay()]}`;
}

export default function Home() {
  usePageMeta({
    title: "黑料每日 - 娱乐热点每日更新帖与汇总清单归档",
    description:
      "黑料每日持续整理娱乐热点动态，提供每日更新帖、按主题整理的汇总清单与历史归档，新增内容一目了然，全量更新不漏任何一条。",
    canonical: "https://ranqiwangyou.cn/",
  });

  const featured = sorted[0];
  const sidePosts = sorted.slice(1, 5);

  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "黑料每日",
          url: "https://ranqiwangyou.cn/",
          description:
            "每日整理娱乐热点、更新帖与汇总清单，并提供历史归档回溯的内容聚合平台。",
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://ranqiwangyou.cn/summary?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: { "@type": "Answer", text: item.a },
          })),
        }}
      />

      <HeroSection
        featured={featured}
        sidePosts={sidePosts}
        todayCount={todayCount}
        dateLabel={formatDateLabel(latestDate)}
      />
      <TodayUpdates posts={sorted} />
      <CategoryBoard />
      <RankingSection />
      <SummaryPreview />
      <FaqSection />
    </>
  );
}